import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosBold } from '../../style/theme';

const { spacing } = theme;

export const StyledPlaceHolderLatestArticlesBase = styled.div``;

export const StyledPlaceHolderLatestArticlesVertical = styled(StyledPlaceHolderLatestArticlesBase)`
    /* padding-left: ${spacing.s}; */
    /* border-left: 1px solid ${theme.palette.red}; */
    ${theme.mediaQueries.mobileMax} {
        text-align: center;
    }
`;

export const StyledPlaceHolderLatestArticlesListHorizontal = styled.ul`
    container-type: inline-size;
`;

export const StyledPlaceHolderLatestArticlesListVertical = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

export const StyledShowMoreButton = styled.button<{ orientation: 'vertical' | 'horizontal' }>`
    background: none;
    border-radius: 4.29rem;
    cursor: pointer;
    border: none;
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    text-transform: uppercase;
    text-align: center;
    width: fit-content;
    padding-inline: clamp(3.36rem, 3.36rem + 0.35vw, 4.29rem);
    padding-block: clamp(1.21rem, 1.21rem + 1.21vw, 1.79rem);
    color: ${theme.palette.red};
    text-decoration: underline;
    padding: 0;
    font-size: 1.43rem;
    letter-spacing: 0;
    line-height: 2.7rem;
    transition: color 0.2s;
    align-self: center;
    ${p => p.orientation === 'horizontal' ? `
        display: block;
        margin: 0 auto;
        margin-top: 2rem;
    ` : ''}

    &:hover {
        color: ${theme.palette.pink};
        svg {
            fill: ${theme.palette.pink};
        }
    }

    ${theme.mediaQueries.mobileMax} {
        font-size: 1.4rem;
        letter-spacing: 0.4px;
        line-height: 2.36rem;
    }
    
    svg {
        margin: auto;
    }
`;
